import posthog from "posthog-js";

// PostHog configuration
export const POSTHOG_KEY = "phc_xD6Hy9FvsDKxJXYFHyA9gRaNOgf1MOGz5LmR4O0LQtB";
export const POSTHOG_HOST = "https://us.i.posthog.com";

export const shouldTrackUser = (email?: string): boolean => {
  if (!email) return true;

  const isInternalEmail = email.toLowerCase().endsWith('@babblebots.ai');
  return !isInternalEmail;
};

export const shouldTrackDomain = (): boolean => {
  if (typeof window === "undefined") return true;

  const hostname = window.location.hostname;
  const href = window.location.href;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return false;
  }

  // Exclude staging domains
  if (href.includes('app-staging.babblebots.ai') ||
    href.includes('interview-staging.babblebots.ai')) {
    return false;
  }

  return true;
};

export const initPostHog = () => {
  if (typeof window !== "undefined" && POSTHOG_KEY) {
    if (!shouldTrackDomain()) {
      console.log("PostHog: Tracking disabled for this domain");
      return;
    }

    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      capture_pageview: false, // We'll manually capture pageviews
      capture_pageleave: true,
      autocapture: true,
      disable_session_recording: false,
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
          password: true,
        },
      },
      before_send: (event) => {
        const email = event.properties?.email || event.properties?.$set?.email;

        if (!shouldTrackUser(email)) {
          console.log("PostHog: Event blocked for internal user", email);
          return null;
        }

        return event;
      },
      loaded: (posthog) => {
        if (process.env.NODE_ENV === "development") {
          console.log("PostHog initialized");
        }
      },
    });
  }
};

export const identifyUser = (
  userId: string,
  userProperties?: Record<string, any>
) => {
  if (posthog && userId) {
    if (!shouldTrackUser(userId)) {
      console.log("babblebots user skippoing tarcking", userId);
      return;
    }

    posthog.identify(userId, userProperties);
  }
};

export const resetUser = () => {
  if (posthog) {
    posthog.reset();
  }
};

// Track custom event
export const trackEvent = (
  eventName: string,
  properties?: Record<string, any>
) => {
  if (posthog) {
    posthog.capture(eventName, properties);
  }
};

// Track page view
export const trackPageView = (
  pageName?: string,
  properties?: Record<string, any>
) => {
  if (posthog) {
    posthog.capture("$pageview", {
      $current_url: window.location.href,
      page_name: pageName,
      ...properties,
    });
  }
};

// Set user properties
export const setUserProperties = (properties: Record<string, any>) => {
  if (posthog) {
    posthog.setPersonProperties(properties);
  }
};

// Track feature flag evaluation
export const isFeatureEnabled = (flagKey: string): boolean => {
  return posthog?.isFeatureEnabled(flagKey) || false;
};

// Get feature flag variant
export const getFeatureFlag = (
  flagKey: string
): string | boolean | undefined => {
  return posthog?.getFeatureFlag(flagKey);
};

export default posthog;
